// ExistingMemberFields.js
import React from 'react';
import { generateTextField } from '../../../b2b-common/helpers';
import { CircularProgress, Switch, Tooltip } from '@mui/material';

const ExistingMemberFields = ({ member, loadingEnableDisableMember, handleSwitchToggle }) => {
    return (
        <div className='existing-member-fields-container'>
            {generateTextField("Email", member.user.email, "membership-info-ro-textfield")}
            {generateTextField("First Name", member.user.firstName, "membership-info-ro-textfield")}
            {generateTextField("Last Name", member.user.lastName, "membership-info-ro-textfield")}
            {generateTextField("Member Since", new Date(member.membershipDate).toLocaleDateString(), "membership-info-ro-textfield")}
            {generateTextField("Last Login", new Date(member.lastLoginDate).toLocaleString(), "membership-info-ro-textfield")}
            <div className="membershipEnabledSwitch">
                <Tooltip title={`Is membership enabled?`} arrow placement="right">
                    <div>
                        {loadingEnableDisableMember ? (
                            <CircularProgress size={20} />
                        ) : (
                            <Switch
                                checked={member.enabled}
                                onChange={handleSwitchToggle}
                                color="primary"
                                inputProps={{ 'aria-label': 'toggle membership enabled' }}
                            />
                        )}
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};

export default ExistingMemberFields;
